import { Injectable } from '@angular/core';
import { FormulaireFiserv } from '../../models/formulaire/formulaire-fiserv.model';
import { FormGroup } from '@angular/forms';
import { RequeteModifierCoordonneesCredit } from '../../api/model/requete-modifier-coordonnees-credit.model';
import { ReponseCoordonneesCreditService } from '../reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { FormulaireFiservService } from '../formulaire-fiserv/formulaire-fiserv.service';

@Injectable({
  providedIn: 'root',
})
export class ConvertisseurDeModelService {
  constructor(
    private readonly formulaireFiservService: FormulaireFiservService,
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService
  ) {}

  construireRequeteModifierCoordonnees(): RequeteModifierCoordonneesCredit {
    const requete: RequeteModifierCoordonneesCredit = {};
    const formulaireFiserv: FormGroup<FormulaireFiserv> = this.formulaireFiservService.getForm();

    if (formulaireFiserv.controls.courriel.value !== this.reponseCoordonneesCreditService.getAdresseCourriel()) {
      requete.adresseCourrielModification = {
        adresseCourriel: formulaireFiserv.value.courriel,
      };
    }
    if (
      formulaireFiserv.controls.telephone.value !== this.reponseCoordonneesCreditService.getTelephone().numeroTelephone
    ) {
      requete.telephonesModification = [
        {
          codeTypeUtilisationTelephone: 'RESIDENTIEL',
          numeroTelephone: this.getNumeroTelephone(formulaireFiserv),
        },
      ];
    }
    if (!formulaireFiserv.controls.utiliserMemeAdresse.value) {
      requete.adresseModification = {
        texteAdresseLigne1: this.getTexteAdresseLigne1(formulaireFiserv),
        nomMunicipalite: formulaireFiserv.controls.ville.value,
        codePostal: this.getCodePostal(formulaireFiserv),
        codeSubdivisionPays: this.getCodeSubdivisionPays(formulaireFiserv),
      };
    }
    return requete;
  }

  private getCodeSubdivisionPays(formulaireFiserv: FormGroup<FormulaireFiserv>) {
    return `CA-${formulaireFiserv.controls.province.value}`;
  }

  private getTexteAdresseLigne1(formulaireFiserv: FormGroup<FormulaireFiserv>): string {
    return formulaireFiserv.controls.appartement.value
      ? `${formulaireFiserv.controls.appartement.value}-${formulaireFiserv.controls.rue.value}`
      : formulaireFiserv.controls.rue.value;
  }

  private getNumeroTelephone(formulaireFiserv: FormGroup<FormulaireFiserv>): string {
    const numero = formulaireFiserv.controls.telephone.value;
    return numero.replace(/[\s-]/g, '');
  }

  private getCodePostal(formulaireFiserv: FormGroup<FormulaireFiserv>): string {
    const codePostal = formulaireFiserv.controls.codePostal.value;
    return codePostal.replace(/\s/g, '');
  }
}
